import styled from "@emotion/styled";

export const Layout = styled.div`
  padding-top: 116px;
`;
